/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectIcon20Solid = forwardRef('CommentRectIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3v1.955a1 1 0 0 0 1.614.79L10.143 15H15a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Z" })));
});
